import { useFeatureToggles } from '@grandvisionhq/state';
import { getBookAppointmentUrl } from '../utils/store-utils.js';
import 'lodash/deburr';

const useBookAppointmentUrl = (baseUrl, store)=>{
    const { featureConfigs: { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } ,  } = useFeatureToggles();
    const bookAppointmentUrlProvider = getBookAppointmentUrl(baseUrl || '', {
        paddedLength: appointmentBookingUrlPaddedLength,
        alternativeUrl: appointmentBookingAlternativeUrl,
        alternativeUrlStores: appointmentBookingAlternativeUrlStores
    });
    return bookAppointmentUrlProvider(store);
};

export { useBookAppointmentUrl };
//# sourceMappingURL=use-book-appointment-url.js.map
